import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import LocalizationForm from '../LocalizationForm/LocalizationForm';
import { useModals } from 'hooks/useModals';
import { useAppDispatch } from 'store/store';

import { TLocalizationFormValues } from '../LocalizationForm/LocalizationForm.types';
import { TLocalizationAdd } from './LocalizationAdd.types';
import { STATIC_LOCALIZATION_FORM_DEFAULT_VALUES } from '../LocalizationForm/constants';

const LocalizationAdd: TLocalizationAdd = () => {
  const dispatch = useAppDispatch();
  const modals = useModals();

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: STATIC_LOCALIZATION_FORM_DEFAULT_VALUES,
  });

  const handleSubmit = (data: TLocalizationFormValues) => {
    // dispatch(
    //   createLocalizationAsyncThunk({
    //     body: data,
    //     onSuccess: () => {
    //       modals.closeModal();
    //       dispatch(getLocalizationListAsyncThunk());
    //     },
    //   })
    // );
  };

  return (
    <FormProvider {...form}>
      <LocalizationForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default LocalizationAdd;
